import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import AdminNavbarItem from '../../src/admin/layout/components/AdminNavbarItem';
import { MANAGE } from '../../modules/authorization/actions';
import { FACILITY_PAGES, NON_FACILITY_PAGES } from '../../modules/authorization/subjects';

const propTypes = {
  active: PropTypes.bool,
};
const defaultProps = {
  active: false,
};

const AdminMediaGalleryNavbarItem = ({ active }) => (
  <AdminNavbarItem
    text="Media Gallery"
    icon="images"
    componentClass={Link}
    to="/admin/media-gallery"
    active={active}
    authorization={{
      action: MANAGE,
      subject: [FACILITY_PAGES, NON_FACILITY_PAGES],
      text: 'manage media gallery images',
    }}
  />
);

AdminMediaGalleryNavbarItem.propTypes = propTypes;
AdminMediaGalleryNavbarItem.defaultProps = defaultProps;

export default AdminMediaGalleryNavbarItem;
